const translations = {
    headerTitle: {
        type: 'text',
        defaultValue: '<b>Witaj</b> w Rehab',
    },
    headerDescription: {
        type: 'text',
        defaultValue: 'Formularz kontaktowy.',
    },
    titlePerson: {
        type: 'text',
        defaultValue: 'Dane osobowe',
    },
    titleMessage: {
        type: 'text',
        defaultValue: 'Wiadomość',
    },
    inputFirstName: {
        type: 'text',
        defaultValue: 'Imię',
    },
    inputLastName: {
        type: 'text',
        defaultValue: 'Nazwisko',
    },
    inputEmail: {
        type: 'text',
        defaultValue: 'Email',
    },
    inputPhone: {
        type: 'text',
        defaultValue: 'Telefon',
    },
    submitButton: {
        type: 'text',
        defaultValue: 'Wyślij wiadomość',
    },
    resultFormTitle: {
        type: 'text',
        defaultValue: 'Dziękujemy!',
    },
    resultFormDescription: {
        type: 'text',
        defaultValue: 'Dziękujemy za wypełnienie formularza kontaktowego. Twoja wiadomość została przekazana do naszego administratora.',
    },
    resultFormButton: {
        type: 'text',
        defaultValue: 'Wróć do strony główej',
    },
};

export default translations;
